import { useState } from 'react';

const KeywordOutput = (props) => {
    const { keywords, label, format, matchType } = props;
    const [copied, setCopied] = useState(false);

    const keywordsAsText = (words) => words.reduce((acc, w) => acc + w + "\n", "");

    const handleCopy = () => {
        navigator.clipboard.writeText(keywordsAsText(keywords));
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }

    return (
        <div className="output-card">
            <div className="output-card-header">
                <span className="output-card-title">{label}</span>
                <span className="output-card-format">{format}</span>
            </div>
            <pre className="output-code">
                {keywordsAsText(keywords.slice(0, 10))}
                {keywords.length > 10 &&
                    <span className="ellipsis">+{keywords.length - 10} more…</span>
                }
            </pre>
            <div className="output-card-footer">
                <button className={`copy-btn${copied ? ' copied' : ''}`} onClick={handleCopy}>
                    {copied
                        ? <><CheckIcon /> Copied!</>
                        : <>Copy all {keywords.length} {matchType} keywords</>
                    }
                </button>
            </div>
        </div>
    );
}

const CheckIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

export default KeywordOutput;
